import styled from "styled-components/macro";
import { Modal } from "@ds/react";

export const GenericModal = styled(Modal)(
  ({ theme: { breakpoint, color, font } }) => ({
    'div[class^="SectionSubtitlestyle__SectionSubtitleContainer"]': {
      paddingBottom: 0,
    },

    'div[class^="Modalstyle__ModalContent"]': {
      padding: "16px",
      maxHeight: "calc(100vh - 80px)",

      [breakpoint.md()]: {
        padding: "36px 60px",
        maxHeight: "unset",
      },
    },

    "h3, h4": {
      display: "block",
      color: color.neutral["02"],
      fontSize: font.size.xl,
      textTransform: "none",
      lineHeight: "42px",

      svg: {
        position: "relative",
        top: "10px",
        marginRight: "8px",
      },
    },

    [breakpoint.lg()]: {
      h3: {
        fontSize: font.size["2xl"],
      },

      "> *": {
        width: "556px",
        borderBottomLeftRadius: "16px",
      },
    },

    [breakpoint.md()]: {
      'div[class^="Modalstyle__Modal"]': {
        width: "556px",
      },
    },
  })
);
